import { render, staticRenderFns } from "./index-noside.vue?vue&type=template&id=33b0dd75&scoped=true&"
import script from "./index-noside.vue?vue&type=script&lang=js&"
export * from "./index-noside.vue?vue&type=script&lang=js&"
import style0 from "./index-noside.vue?vue&type=style&index=0&id=33b0dd75&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b0dd75",
  null
  
)

export default component.exports